export const zoomOptions = "M$a";
export const zoomReset = "N$a";
export const zoomIn = "O$a";
export const zoomOut = "P$a";
export default {zoomOptions,zoomReset,zoomIn,zoomOut};